import Vue from 'vue'
import VueRouter from "vue-router"
import token from "./token"

Vue.use(VueRouter)
//解决vue路由重复导航错误
//获取原型对象上的push函数
const originalPush = VueRouter.prototype.push
//修改原型对象中的push方法
VueRouter.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

const router = new VueRouter({
	routes: [
		/* 前端首页 */
		{
			path: '/',
			name: 'fIndex',
			component: () => import('./views/front/Index.vue'),
			meta: {
				title: '首页',
				requireLogin: false
			}
		},
		/* 健康检测详情页 */
		{
			path: '/health-detection',
			name: 'healthDetection',
			component: () => import('./views/front/HealthDetectionDetail.vue'),
			meta: {
				title: '健康检测服务',
				requireLogin: false
			}
		},
		/* 专家团队详情页 */
		{
			path: '/expert-team',
			name: 'expertTeam',
			component: () => import('./views/front/ExpertTeamDetail.vue'),
			meta: {
				title: '专家团队',
				requireLogin: false
			}
		},
		/* 专家详情页 */
		{
			path: '/expert-profile',
			name: 'expertProfile',
			component: () => import('./views/front/ExpertProfile.vue'),
			meta: {
				title: '专家详情',
				requireLogin: false
			}
		},
		/* 新闻列表页 */
		{
			path: '/news',
			name: 'news',
			component: () => import('./views/front/NewsList.vue'),
			meta: {
				title: '行业资讯',
				requireLogin: false
			}
		},
		/* 新闻详情页 */
		{
			path: '/news-detail',
			name: 'newsDetail',
			component: () => import('./views/front/newsDetail.vue'),
			meta: {
				title: '新闻详情',
				requireLogin: false
			}
		},
		/* 案例列表页 */
		{
			path: '/cases',
			name: 'cases',
			component: () => import('./views/front/CaseList.vue'),
			meta: {
				title: '成功案例',
				requireLogin: false
			}
		},
		/* 案例详情页 */
		{
			path: '/case-detail',
			name: 'caseDetail',
			component: () => import('./views/front/CaseDetail.vue'),
			meta: {
				title: '案例详情',
				requireLogin: false
			}
		},
		/* 健康管理服务页 */
		{
			path: '/health-management',
			name: 'healthManagement',
			component: () => import('./views/front/HealthManagement.vue'),
			meta: {
				title: '健康管理服务',
				requireLogin: false
			}
		},
		/* 调理服务页 */
		{
			path: '/conditioning-service',
			name: 'conditioningService',
			component: () => import('./views/front/ConditioningService.vue'),
			meta: {
				title: '调理服务',
				requireLogin: false
			}
		},
		/* 预约服务页 */
		{
			path: '/appointment-service',
			name: 'appointmentService',
			component: () => import('./views/front/AppointmentService.vue'),
			meta: {
				title: '预约服务',
				requireLogin: false
			}
		},
		/* 调理服务详情页 */
		{
			path: '/conditioning-service-detail',
			name: 'conditioningServiceDetail',
			component: () => import('./views/front/ConditioningServiceDetail.vue'),
			meta: {
				title: '调理服务详情',
				requireLogin: false
			}
		},
		/* 健康管理服务详情页 */
		{
			path: '/health-service-detail',
			name: 'healthServiceDetail',
			component: () => import('./views/front/HealthServiceDetail.vue'),
			meta: {
				title: '服务详情',
				requireLogin: false
			}
		},
		/* 手机端前端首页 */
		{
			path: '/phone/login',
			name: 'pLogin',
			component: () => import('./views/phone/login.vue'),
			meta: {
				title: '首页',
				requireLogin: false
			}
		},
		/* 手机端前端首页 */
		{
			path: '/phone/forgetPass',
			name: 'pForgetPass',
			component: () => import('./views/phone/forgetPass.vue'),
			meta: {
				title: '首页',
				requireLogin: false
			}
		},
		/* 手机端前端首页 */
		{
			path: '/phone/reservation',
			name: 'pReservation',
			component: () => import('./views/phone/reservation.vue'),
			meta: {
				title: '首页',
				requireLogin: false
			}
		},
		/* 手机端前端首页 */
		{
			path: '/phone/feedback',
			name: 'pFeedback',
			component: () => import('./views/phone/feedback.vue'),
			meta: {
				title: '首页',
				requireLogin: false
			}
		},
		/* 手机端前端首页 */
		{
			path: '/phone/conditioning',
			name: 'pConditioning',
			component: () => import('./views/phone/conditioning.vue'),
			meta: {
				title: '首页',
				requireLogin: false
			}
		},
		/* 手机端前端首页 */
		{
			path: '/phone/index',
			name: 'pIndex',
			component: () => import('./views/phone/Index.vue'),
			meta: {
				title: '首页',
				requireLogin: false
			}
		},
		/* 手机端公司简介 */
		{
			path: '/phone/aboutUs',
			name: 'pAboutUs',
			component: () => import('./views/phone/aboutUs.vue'),
			meta: {
				title: '首页',
				requireLogin: false
			}
		},
		/* 手机端发展历程 */
		{
			path: '/phone/developmentHistory',
			name: 'pDevelopmentHistory',
			component: () => import('./views/phone/developmentHistory.vue'),
			meta: {
				title: '首页',
				requireLogin: false
			}
		},
		/* 手机端荣誉奖项 */
		{
			path: '/phone/honoraryAwards',
			name: 'pHonoraryAwards',
			component: () => import('./views/phone/honoraryAwards.vue'),
			meta: {
				title: '首页',
				requireLogin: false
			}
		},
		/* 手机端红色建设 */
		{
			path: '/phone/redConstruction',
			name: 'pRedConstruction',
			component: () => import('./views/phone/redConstruction.vue'),
			meta: {
				title: '首页',
				requireLogin: false
			}
		},
		/* 手机端红色建设详情 */
		{
			path: '/phone/redConstructionDetail',
			name: 'pRedConstructionDetail',
			component: () => import('./views/phone/redConstructionDetail.vue'),
			meta: {
				title: '首页',
				requireLogin: false
			}
		},
		/* 手机端和华文化 */
		{
			path: '/phone/hehuaCulture',
			name: 'pHehuaCulture',
			component: () => import('./views/phone/hehuaCulture.vue'),
			meta: {
				title: '首页',
				requireLogin: false
			}
		},
		/* 手机端和华文化详情 */
		{
			path: '/phone/hehuaCultureDetail',
			name: 'pHehuaCultureDetail',
			component: () => import('./views/phone/hehuaCultureDetail.vue'),
			meta: {
				title: '首页',
				requireLogin: false
			}
		},
		/* 手机端业务领域 */
		{
			path: '/phone/businessArea',
			name: 'pBusinessArea',
			component: () => import('./views/phone/businessArea.vue'),
			meta: {
				title: '首页',
				requireLogin: false
			}
		},
		/* 手机端业务领域详情 */
		{
			path: '/phone/businessAreaDetail',
			name: 'pBusinessAreaDetail',
			component: () => import('./views/phone/businessAreaDetail.vue'),
			meta: {
				title: '首页',
				requireLogin: false
			}
		},
		/* 手机端专业人员 */
		{
			path: '/phone/professional',
			name: 'pProfessional',
			component: () => import('./views/phone/professional.vue'),
			meta: {
				title: '首页',
				requireLogin: false
			}
		},
		/* 手机端专业人员详情 */
		{
			path: '/phone/professionalDetail',
			name: 'pProfessionalDetail',
			component: () => import('./views/phone/professionalDetail.vue'),
			meta: {
				title: '首页',
				requireLogin: false
			}
		},
		/* 手机端资讯动态 */
		{
			path: '/phone/news',
			name: 'pNews',
			component: () => import('./views/phone/news.vue'),
			meta: {
				title: '首页',
				requireLogin: false
			}
		},
		/* 手机端资讯动态详情 */
		{
			path: '/phone/newsDetail',
			name: 'pNewsDetail',
			component: () => import('./views/phone/newsDetail.vue'),
			meta: {
				title: '首页',
				requireLogin: false
			}
		},
		/* 手机端经典案例 */
		{
			path: '/phone/classicCases',
			name: 'pClassicCases',
			component: () => import('./views/phone/classicCases.vue'),
			meta: {
				title: '首页',
				requireLogin: false
			}
		},
		/* 手机端经典案例详情 */
		{
			path: '/phone/classicCasesDetail',
			name: 'pClassicCasesDetail',
			component: () => import('./views/phone/classicCasesDetail.vue'),
			meta: {
				title: '首页',
				requireLogin: false
			}
		},
		/* 手机端专业文章 */
		{
			path: '/phone/professionalArticles',
			name: 'pProfessionalArticles',
			component: () => import('./views/phone/professionalArticles.vue'),
			meta: {
				title: '首页',
				requireLogin: false
			}
		},
		/* 手机端专业文章详情 */
		{
			path: '/phone/professionalArticlesDetail',
			name: 'pProfessionalArticlesDetail',
			component: () => import('./views/phone/professionalArticlesDetail.vue'),
			meta: {
				title: '首页',
				requireLogin: false
			}
		},
		/* 手机端联系我们 */
		{
			path: '/phone/contactUs',
			name: 'pContactUs',
			component: () => import('./views/phone/contactUs.vue'),
			meta: {
				title: '首页',
				requireLogin: false
			}
		},
		/* 手机端加入我们 */
		{
			path: '/phone/joinUs',
			name: 'pJoinUs',
			component: () => import('./views/phone/joinUs.vue'),
			meta: {
				title: '首页',
				requireLogin: false
			}
		},
		/* 手机端加入我们详情 */
		{
			path: '/phone/joinUsDetail',
			name: 'pJoinUsDetail',
			component: () => import('./views/phone/joinUsDetail.vue'),
			meta: {
				title: '首页',
				requireLogin: false
			}
		},
		/* 手机端免责条款 */
		{
			path: '/phone/disclaimer',
			name: 'pDisclaimer',
			component: () => import('./views/phone/disclaimer.vue'),
			meta: {
				title: '首页',
				requireLogin: false
			}
		},
		/* 手机端隐私政策 */
		{
			path: '/phone/privacyPolicy',
			name: 'pPrivacyPolicy',
			component: () => import('./views/phone/privacyPolicy.vue'),
			meta: {
				title: '首页',
				requireLogin: false
			}
		},
		/* 后台主页 */
		{
			path: '/admin/index',
			name: 'index',
			component: () => import('./views/admin/Index'),
			// component: () => import('./views/admin/news/ArticleIndex.vue'),
			children: [
				//个人信息
				{
					path: '/admin/userinfo',
					name: 'userinfo',
					component: () => import('./views/admin/authority/user/UserInfo.vue'),
				},
				//用户管理
				{
					path: '/admin/authority/userindex',
					name: 'userindex',
					component: () => import('./views/admin/authority/user/UserIndex.vue'),
				}, 
				//内容管理-栏目管理
				{
					path: '/admin/content/channelindex',
					name: 'channelindex',
					component: () => import('./views/admin/content/channel/ChannelIndex.vue'),
				}, 
				{
					path: '/admin/content/channel_add',
					name: 'channel_add',
					component: () => import('./views/admin/content/channel/ChannelAdd.vue'),
				}, 
				{
					path: '/admin/content/channel_edit',
					name: 'channel_edit',
					component: () => import('./views/admin/content/channel/ChannelEdit.vue'),
				}, 
				//内容管理-轮播图管理
				// {
				// 	path: '/admin/content/slideshowindex',
				// 	name: 'slideshowindex',
				// 	component: () => import('./views/admin/content/slideshow/SlideshowIndex.vue'),
				// }, 
				// //业务管理-业务景区
				// {
				// 	path: '/admin/business/scenicindex',
				// 	name: 'scenicindex',
				// 	component: () => import('./views/admin/business/scenic/ScenicIndex.vue'),
				// }, 
				// {
				// 	path: '/admin/business/scenic_add',
				// 	name: 'scenic_add',
				// 	component: () => import('./views/admin/business/scenic/ScenicAdd.vue'),
				// }, 
				// {
				// 	path: '/admin/business/scenic_edit',
				// 	name: 'scenic_edit',
				// 	component: () => import('./views/admin/business/scenic/ScenicEdit.vue'),
				// }, 
				// //业务管理-软件成果
				// {
				// 	path: '/admin/business/softwareindex',
				// 	name: 'softwareindex',
				// 	component: () => import('./views/admin/business/software/SoftwareIndex.vue'),
				// }, 
				// {
				// 	path: '/admin/business/software_add',
				// 	name: 'software_add',
				// 	component: () => import('./views/admin/business/software/SoftwareAdd.vue'),
				// }, 
				// {
				// 	path: '/admin/business/software_edit',
				// 	name: 'software_edit',
				// 	component: () => import('./views/admin/business/software/SoftwareEdit.vue'),
				// }, 
				//新闻管理-文章管理
				{
					path: '/admin/news/articleindex',
					name: 'articleindex',
					component: () => import('./views/admin/news/ArticleIndex.vue'),
				},
				{
					path: '/admin/news/article_add',
					name: 'article_add',
					component: () => import('./views/admin/news/ArticleAdd.vue'),
				}, 
				{
					path: '/admin/news/article_edit',
					name: 'article_edit',
					component: () => import('./views/admin/news/ArticleEdit.vue'),
				}, 
				//业务管理
				{
					path: '/admin/service/serviceindex',
					name: 'serviceindex',
					component: () => import('./views/admin/service/ServiceIndex.vue'),
				},
				{
					path: '/admin/service/service_add',
					name: 'service_add',
					component: () => import('./views/admin/service/ServiceAdd.vue'),
				}, 
				{
					path: '/admin/service/service_edit',
					name: 'service_edit',
					component: () => import('./views/admin/service/ServiceEdit.vue'),
				}, 
				//律师管理
				{
					path: '/admin/lawyer/lawyerindex',
					name: 'lawyerindex',
					component: () => import('./views/admin/lawyer/LawyerIndex.vue'),
				},
				{
					path: '/admin/lawyer/lawyer_add',
					name: 'lawyer_add',
					component: () => import('./views/admin/lawyer/LawyerAdd.vue'),
				}, 
				{
					path: '/admin/lawyer/lawyer_edit',
					name: 'lawyer_edit',
					component: () => import('./views/admin/lawyer/LawyerEdit.vue'),
				},  
				//和华文化
				{
					path: '/admin/culture/cultureindex',
					name: 'cultureindex',
					component: () => import('./views/admin/culture/CultureIndex.vue'),
				},
				{
					path: '/admin/culture/culture_add',
					name: 'culture_add',
					component: () => import('./views/admin/culture/CultureAdd.vue'),
				}, 
				{
					path: '/admin/culture/culture_edit',
					name: 'culture_edit',
					component: () => import('./views/admin/culture/CultureEdit.vue'),
				}, 
				//留言管理
				{
					path: '/admin/leaveMassage/leaveMassageindex',
					name: 'leaveMassageindex',
					component: () => import('./views/admin/leaveMassage/LeaveMassageIndex.vue'),
				},
				{
					path: '/admin/leaveMassage/leaveMassage_add',
					name: 'leaveMassage_add',
					component: () => import('./views/admin/leaveMassage/LeaveMassageAdd.vue'),
				}, 
				{
					path: '/admin/leaveMassage/leaveMassage_edit',
					name: 'leaveMassage_edit',
					component: () => import('./views/admin/leaveMassage/LeaveMassageEdit.vue'),
				}, 
				//关于我们
				{
					path: '/admin/aboutUs/aboutUsindex',
					name: 'aboutUsindex',
					component: () => import('./views/admin/aboutUs/AboutUsIndex.vue'),
				},
				{
					path: '/admin/aboutUs/aboutUs_add',
					name: 'aboutUs_add',
					component: () => import('./views/admin/aboutUs/AboutUsAdd.vue'),
				}, 
				{
					path: '/admin/aboutUs/aboutUs_edit',
					name: 'aboutUs_edit',
					component: () => import('./views/admin/aboutUs/AboutUsEdit.vue'),
				}, 
				//加入我们
				{
					path: '/admin/joinUs/joinUsindex',
					name: 'joinUsindex',
					component: () => import('./views/admin/joinUs/JoinUsIndex.vue'),
				},
				{
					path: '/admin/joinUs/joinUs_add',
					name: 'joinUs_add',
					component: () => import('./views/admin/joinUs/JoinUsAdd.vue'),
				}, 
				{
					path: '/admin/joinUs/joinUs_edit',
					name: 'joinUs_edit',
					component: () => import('./views/admin/joinUs/JoinUsEdit.vue'),
				}, 
				//招聘管理
				{
					path: '/admin/recruit/recruitindex',
					name: 'recruitindex',
					component: () => import('./views/admin/recruit/RecruitIndex.vue'),
				}, 
			]
		}
	]

})
router.beforeEach(async(to, from, next) => {
	// if(to.path.includes('admin')){
		document.title = "Health"
	// }
	if (!to.matched.some(r => r.meta.requireLogin)) {
		next();
	} else {
		if (token.get()) {
			next()
		} else {
			if (to.path === '/login') {
				next()
			} else {
				next('/login')
			}
		}
	}
})

export default router
